export const PRODUCT_TYPES = ['h-basic', 'h-plus', 'h-ultra', 'next-gen']
